<div class="card" *ngIf="item">
  <div class="card__img">
    <img *ngIf="item.gallery && item.gallery[0]?.image" [src]="item.gallery[0].image.url" [alt]="item.gallery[0].name || item.name" />
  </div>
  <div class="card__line"></div>
  <div class="card__title">
    <span class="card__title--eyebrow">Purificador</span>
    <h3 [innerHTML]="item.name"></h3>
  </div>
  <button class="card__btn" (click)="openModal(item)">
    {{ knowBtn }}
  </button>
</div>
